<div>
  <form [formGroup]="form" appPermissionControl="P199F0001">
    <div class="card-header">
      <div class="title-section">
        <h5 class="header-title">{{ modelRecived ? 'Editar' : 'Nuevo' }} Tipo de Producto</h5>
      </div>
      <div class="button-section">
        <button
          mat-flat-button
          (click)="modelRecived ? update(form.value) : create(form.value)"
          class="{{ modelRecived ? 'btn-edit' : 'btn-success' }}"
          [disabled]="!form.valid"
          appPermissionControl="P199B0002"
        >
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button mat-flat-button class="btn-search" (click)="customizables()" *ngIf="modelRecived" appPermissionControl="P199B0005">
          <mat-icon>receipt</mat-icon>
          Customizables
        </button>
        <button mat-flat-button class="btn-search" (click)="openFirmasDialog()" *ngIf="modelRecived" appPermissionControl="P199B0006">
          <mat-icon>edit</mat-icon>
          Firmas
        </button>
        <button mat-flat-button (click)="close()" class="btn-delete" appPermissionControl="P199B0001">
          <mat-icon>close</mat-icon>
          Cerrar
        </button>
      </div>
    </div>

    <div class="form-row mt-5">
      <div class="form-field">
        <input
          type="text"
          formControlName="producto"
          class="form-control"
          placeholder="Ingrese tipo de préstamo"
          [readonly]="modelRecived"
          [ngClass]="{ invalid: form.controls['producto'].invalid && form.controls['producto'].touched }"
          appPermissionControl="P199K0001"
        />
        <label>Tipo de Producto</label>
      </div>
      <div class="form-field">
        <input
          type="text"
          formControlName="descripcion"
          class="form-control"
          placeholder="Ingrese descripción"
          [ngClass]="{ invalid: form.controls['descripcion'].invalid && form.controls['descripcion'].touched }"
          appPermissionControl="P199K0004"
        />
        <label>Descripción</label>
      </div>
      <div class="form-field">
        <select formControlName="tipoCredito" class="form-control" appPermissionControl="P199K0002">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let tipoCre of tiposCredito" [value]="tipoCre.valor">
            {{ tipoCre.opcion }}
          </option>
        </select>
        <label>Tipo de Ahorro</label>
      </div>
      <div class="form-field">
        <select formControlName="empresa" class="form-control" appPermissionControl="P199K0003">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let empresa of empresas" [value]="empresa.sEmpresa.trim()">{{ empresa.sEmpresa.trim() }} | {{ empresa.sNombre.trim() }}</option>
        </select>
        <label>Compañía</label>
      </div>
    </div>
    <hr />
    <h2 class="header-title">Generales</h2>
    <div class="form-row">
      <div class="form-field">
        <select
          formControlName="rutaCriticaAutomatica"
          class="form-control"
          appPermissionControl="P199K0005"
        >
          <option value="">-- Seleccione --</option>
          <option *ngFor="let ruta of rutasCriticas" [value]="ruta.numero_Proceso">
            {{ ruta.numero_Proceso }} | {{ ruta.descriptivo }}
          </option>
        </select>
        <label>Ruta Crítica Auto</label>
      </div>
      <div class="form-field">
        <select formControlName="moneda" class="form-control" appPermissionControl="P199K0007">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let itemMoneda of monedas" [value]="itemMoneda.moneda.trim()">{{ itemMoneda.moneda.trim() }} | {{ itemMoneda.descripcion.trim() }}</option>
        </select>
        <label>Moneda</label>
      </div>
      <div class="form-field">
        <input
          type="date"
          formControlName="fechaFin"
          class="form-control"
          [ngClass]="{ invalid: form.controls['fechaFin'].invalid && form.controls['fechaFin'].touched }"
          appPermissionControl="P199K0006"
        />
        <label>Fecha de Vigencia</label>
      </div>
      <div class="form-field">
        <input
          type="number"
          formControlName="orden"
          class="form-control"
          placeholder="Ingrese orden"
          [ngClass]="{ invalid: form.controls['orden'].invalid && form.controls['orden'].touched }"
          appPermissionControl="P199K0008"
        />
        <label>Orden</label>
      </div>
    </div>
    <hr />
    <h2 class="header-title">Características</h2>
    <div class="form-row">
      <div class="form-field">
        <select
          formControlName="tablaScoring"
          class="form-control"
          [ngClass]="{ invalid: form.controls['tablaScoring'].invalid && form.controls['tablaScoring'].touched }"
          appPermissionControl="P199K0009"
        >
          <option value="">-- Seleccione --</option>
          <option *ngFor="let opcion of opcionesTablaScoring" [value]="opcion.sValor">
            {{ opcion.sOpcion }}
          </option>
        </select>
        <label>Tabla</label>
      </div>
      <div class="form-field">
        <select
          formControlName="frecuenciaPago"
          class="form-control"
          [ngClass]="{ invalid: form.controls['frecuenciaPago'].invalid && form.controls['frecuenciaPago'].touched }"
          appPermissionControl="P199K0014"
        >
          <option value="">-- Seleccione --</option>
          <option *ngFor="let opcion of opcionesFrecuenciaPago" [value]="opcion.sValor">
            {{ opcion.sOpcion }}
          </option>
        </select>
        <label>Frecuencia de Pago</label>
      </div>
      <div class="form-field">
        <select formControlName="tipoTasa" class="form-control" appPermissionControl="P199K0010">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let tasa of tiposTasa" [value]="tasa.valor">
            {{ tasa.opcion }}
          </option>
        </select>
        <label>Tipo de Tasa</label>
      </div>
      <div class="form-field">
        <input
          type="number"
          formControlName="plazoMinimo"
          class="form-control"
          placeholder="Ingrese plazo mínimo"
          [ngClass]="{ invalid: form.controls['plazoMinimo'].invalid && form.controls['plazoMinimo'].touched }"
          appPermissionControl="P199K0011"
        />
        <label>Plazo Mínimo</label>
      </div>
      <div class="form-field">
        <input
          type="number"
          formControlName="plazoMaximo"
          class="form-control"
          placeholder="Ingrese plazo máximo"
          [ngClass]="{ invalid: form.controls['plazoMaximo'].invalid && form.controls['plazoMaximo'].touched }"
          appPermissionControl="P199K0015"
        />
        <label>Plazo Máximo</label>
      </div>
      <div class="form-field">
        <input
          type="number"
          formControlName="tasaMinima"
          class="form-control"
          placeholder="Ingrese tasa mínima"
          [ngClass]="{ invalid: form.controls['tasaMinima'].invalid && form.controls['tasaMinima'].touched }"
          appPermissionControl="P199K0012"
        />
        <label>Tasa Mínima</label>
      </div>
      <div class="form-field">
        <input
          type="number"
          formControlName="tasaMaxima"
          class="form-control"
          placeholder="Ingrese tasa máxima"
          [ngClass]="{ invalid: form.controls['tasaMaxima'].invalid && form.controls['tasaMaxima'].touched }"
          appPermissionControl="P199K0016"
        />
        <label>Tasa Máxima</label>
      </div>
      <div class="form-field">
        <input
          type="number"
          formControlName="pagoMinimo"
          class="form-control"
          placeholder="Ingrese pago mínimo"
          [ngClass]="{ invalid: form.controls['pagoMinimo'].invalid && form.controls['pagoMinimo'].touched }"
          appPermissionControl="P199K0013"
        />
        <label>Pago Mínimo</label>
      </div>
      <div class="form-field">
        <select formControlName="uso" class="form-control" appPermissionControl="P199K0017">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let use of uso" [value]="use.valor">
            {{ use.opcion }}
          </option>
        </select>
        <label>Check List</label>
      </div>
    </div>
  </form>
</div>

<!-- Diálogo de Firmas -->
<p-dialog
  [(visible)]="displayFirmasDialog"
  [style]="{ width: '80vw' }"
  [contentStyle]="{ padding: '1rem' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="hideFirmasDialog()"
  header="Firmas - {{ modelRecived?.descripcion }}"
>
  <div class="card-header mb-3">
    <div class="button-section">
      <div class="p-input-icon-left search-input">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dtFirmas.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." appPermissionControl="P199K0001" />
        </span>
      </div>
      <button mat-flat-button (click)="openNewFirma()" class="btn-new" appPermissionControl="P199B0007">
        <mat-icon>add</mat-icon> Nuevo
      </button>
    </div>
  </div>

  <p-table
    #dtFirmas
    [value]="firmasDataSource"
    [columns]="firmasColumns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 20, 40]"
    [scrollable]="true"
    [scrollHeight]="'400px'"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [globalFilterFields]="['control', 'tipo', 'cutOff', 'inferior', 'superior', 'requerida']"
    appendTo="body"
    [loading]="firmasLoading"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P199T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P199C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex align-items-center justify-content-center gap-2">
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-info p-button-text"
                  (click)="verFirma(rowData)"
                  appPermissionControl="P199B0009"
                ></button>
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="eliminarFirma(rowData)"
                  appPermissionControl="P199B0011"
                ></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'inferior'">
              {{ formatNumber(rowData[col.field]) }}
            </ng-container>
            <ng-container *ngSwitchCase="'superior'">
              {{ formatNumber(rowData[col.field]) }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="firmasColumns.length" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- Diálogo para Nueva Firma -->
<p-dialog
  [(visible)]="displayNuevaFirmaDialog"
  [style]="{ width: '400px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="hideNuevaFirmaDialog()"
  [header]="isEditMode ? 'Editar Firma' : 'Nueva Firma'"
>
  <form [formGroup]="nuevaFirmaForm" (ngSubmit)="onSubmitNuevaFirma()" appPermissionControl="P199F0002">
    <div class="form-row">
      <div class="form-field flex-grow-1">
        <p-dropdown 
          formControlName="cutOff" 
          appendTo="body" 
          [options]="opcionesCutOff" 
          optionLabel="descripcion" 
          optionValue="valor" 
          placeholder="Seleccione CutOff" 
          class="w-100" 
          [loading]="firmasLoading" 
          appPermissionControl="P199K0018">
        </p-dropdown>
        <label>CutOff</label>
      </div>
      <div class="form-field flex-grow-1">
        <input 
          pInputText 
          formControlName="rangoInferior" 
          placeholder="Ingrese rango inferior" 
          class="w-100" 
          appPermissionControl="P199K0019">
        <label>R. Inferior</label>
      </div>
      <div class="form-field flex-grow-1">
        <input 
          pInputText 
          formControlName="rangoSuperior" 
          placeholder="Ingrese rango superior" 
          class="w-100" 
          appPermissionControl="P199K0020">
        <label>R. Superior</label>
      </div>
      <div class="form-field flex-grow-1">
        <input 
          pInputText 
          formControlName="firmas" 
          placeholder="Ingrese firmas" 
          class="w-100" 
          appPermissionControl="P199K0021">
        <label>Firmas</label>
      </div>
    </div>

    <div class="button-section mt-3">
      <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!nuevaFirmaForm.valid || isSubmittingFirma" appPermissionControl="P199B0012">
        <mat-icon>save</mat-icon>
        {{ isSubmittingFirma ? (isEditMode ? 'Actualizando...' : 'Guardando...') : (isEditMode ? 'Actualizar' : 'Guardar') }}
      </button>
    </div>
  </form>
</p-dialog>
